export default "__VITE_ASSET__C_AO3VFV__"